import AgOrderList from '@/pages/orderManage/agOrderList'
import AgOrderDetail from '@/pages/orderManage/agOrderList/OrderDetail'

export default [
  {
    path: '/agOrderList',
    name: 'AgOrderList',
    component: AgOrderList,
    meta: { name: '订单列表' }
  },
  {
    path: '/agOrderList/orderDetail/:orderId',
    name: 'AgOrderDetail',
    component: AgOrderDetail,
    props: true,
    meta: { name: ['订单列表', '订单详情'] }
  }
]



// WEBPACK FOOTER //
// ./src/router/orderManage/agOrderList.js